enum RecommendationsFirstLoadVisibility {
  Hidden = 'hidden',
  OrderHistory = 'order-history',
  PredictionsAndOrderHistory = 'predictions-and-order-history',
}

export { RecommendationsFirstLoadVisibility };
